import { render, staticRenderFns } from "./RequestVam.vue?vue&type=template&id=4b5fdbdf&scoped=true&"
import script from "./RequestVam.vue?vue&type=script&lang=js&"
export * from "./RequestVam.vue?vue&type=script&lang=js&"
import style0 from "./RequestVam.vue?vue&type=style&index=0&id=4b5fdbdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5fdbdf",
  null
  
)

export default component.exports